import { PortalServiceV1 } from '@esportal/esportal-feature-app-root/packages/portal-service/src/v1';
import { LayerManagerV24 } from '@volkswagen-onehub/layer-manager';
import { ServiceConfigProviderV1 } from '@volkswagen-onehub/service-config-provider';
import React, { useContext } from 'react';
import { OneformFeatureAppDependencies } from '..';

export interface IOneFormV2Context {
	readonly featureAppId: string;
	readonly portalService: PortalServiceV1;
	readonly layerManager: LayerManagerV24;
	readonly serviceConfigProvider: ServiceConfigProviderV1;
	readonly featureServices: OneformFeatureAppDependencies | null;
}

const defaultContext: IOneFormV2Context = {
	featureAppId: '',
	portalService: {} as PortalServiceV1,
	layerManager: {} as LayerManagerV24,
	serviceConfigProvider: {} as ServiceConfigProviderV1,
	featureServices: null,
};

export const OneFormV2Context = React.createContext<IOneFormV2Context>(defaultContext);
OneFormV2Context.displayName = 'OneFormV2Context';

export const useFeatureServices = (): OneformFeatureAppDependencies => {
	const { featureServices } = useContext(OneFormV2Context);
	if (!featureServices) {
		throw new Error('No featureServices context value was provided.');
	}

	return featureServices;
};
